import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import Loader from '../../common/Loader';

import { browserDeeplink } from '../../../../lib/browser-deeplink';
import { isAndroid, isIOS, isMacOS, isMobile, isWindows } from '../../../utils/platformResolver';
import { defaultLinks, fetchPersonalizedLinksWithAppUrl } from '../../../utils/downloadLinks';

import styles from '../DeviceManagement.scss';

const LinkCurrentDeviceButton = ({ children, downloadToken, refreshDownloadToken, className = '' }) => {
  const [appLink, setAppLink] = useState('/');
  const [downloadLinks, setDownloadLinks] = useState(defaultLinks);
  const [isMobileLink] = useState(isMobile());
  useEffect(() => {
    const appUrl = new URL('clearvpn://go/register');
    appUrl.searchParams.append('permanent_token', downloadToken);

    if (isAndroid()) {
      setAppLink(`${defaultLinks.android}?permanent_token=${downloadToken}`);
    } else if (isIOS()) {
      setAppLink(`${defaultLinks.ios}?permanent_token=${downloadToken}`);
    } else {
      setAppLink(`clearvpn://go/register?permanent_token=${downloadToken}`);
    }

    fetchPersonalizedLinksWithAppUrl(appUrl)
      .then((links) => {
        setDownloadLinks(links);
      });
  }, [downloadToken]);
  const onClick = () => {
    if (!appLink) {
      return;
    } else if (isMobileLink) {
      refreshDownloadToken();

      return;
    }

    browserDeeplink(appLink)
      .catch(() => {
        if (isMacOS()) {
          location.href = downloadLinks.macos;
        } else if (isWindows()) {
          location.href = downloadLinks.windows;
        }
      })
      .then(refreshDownloadToken);
  };

  return (
    <a
      href={isMobileLink ? appLink : undefined}
      onClick={onClick}
      className={clsx(styles.autoLoginSectionButton, className)}
    >
      {
        appLink
          ? children
          : <Loader />
      }
    </a>
  );
};

export default LinkCurrentDeviceButton;
